import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { ArrowRight, ArrowLeft } from 'pcln-icons'

const Left = styled(ArrowLeft)`
  margin-right: -4px;
`

const Right = styled(ArrowRight)`
  margin-left: -4px;
`

export function ArrowRoundTrip({ color, size }) {
  return (
    <React.Fragment>
      <Left color={color} size={size} />
      <Right color={color} size={size} />
    </React.Fragment>
  )
}

ArrowRoundTrip.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
}
